import * as React from "react"
const BlueSquareNew = (props:any) => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M5 4H17C17.5523 4 18 4.44772 18 5V17C18 17.5523 17.5523 18 17 18H5C4.44772 18 4 17.5523 4 17V5C4 4.44772 4.44772 4 5 4Z" 
      fill="#3560DA"
    />
  </svg>
)
export default BlueSquareNew
